<template>
  <div>
    <h4 v-if="company">Pricing for {{company.name}}</h4>
    <div v-else>
      <h3>Base Pricing</h3>
      <div class="mb-2">These per-node prices are used when company-specific pricing is not set.</div>
    </div>
    <hr />
    <div class="grid-container">
      <div
        class
        v-for="(nodeType, i) in node_types"
        :key="`${!!company ? company.id : 'BASE'}-${nodeType}`"
        :style="`grid-column-start: ${i % 2 == 0 ? 1 : 3}`"
      >
        <b-form-group :label="display_map[nodeType]" :key="priceMap.toString()">
          <b-form-input
            v-model="priceMap[nodeType]"
            :placeholder="`DEFAULT (${basePricing[nodeType]})`"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <loading-panel :loading="loading" class="py-3">
      <button class="btn btn-primary w-25" @click.prevent="save">Save</button>
    </loading-panel>
    <error-panel class="m-auto" :errors="errors"></error-panel>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  name: "company",
  components: {},
  props: {
    company: {},
    basePricing: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    node_types: [
      "panel",
      "mcc",
      "vfd",
      "breaker",
      "starter",
      "softstart",
      "auxnode",
      "switchboard",
      "distributionPanelboard",
      "transformer",
      "disconnectSwitch",
      "fuse"
    ],
    display_map: {
      panel: "Panels",
      mcc: "MCCs",
      vfd: "VFDs",
      breaker: "Breakers",
      starter: "Starters",
      softstart: "Softstarts",
      auxnode: "Aux Nodes",
      switchboard: "Switchboards",
      distributionPanelboard: "Distribution Panelboards",
      transformer: "Transformers",
      disconnectSwitch: "Disconnect Switches",
      fuse: "Fuses"
    },
    priceMap: {}
  }),
  methods: {
    getOriginalPriceMap() {
      let sourceMap = !!this.company ? this.company.pricing : this.basePricing;
      return !!sourceMap ? sourceMap : {};
    },
    setPriceMap(target, source) {
      this.node_types.forEach(nodeType => {
        target[nodeType] = source[nodeType];
      });
    },
    initPriceMap() {
      this.setPriceMap(this.priceMap, this.getOriginalPriceMap());
      this.$forceUpdate();
    },
    async save() {
      try {
        this.loading = true;
        const response = await this.$web.updatePricing(
          !!this.company ? this.company.id : 0,
          this.priceMap
        );

        // Save our changes to local cached price structure held in parent
        if (response.data.pricing) {
          this.setPriceMap(this.getOriginalPriceMap(), response.data.pricing);
        }
      } catch (err) {
        console.log(err);
        this.errors = ["An error occurred."];
      } finally {
        this.loading = false;
      }
    }
  },
  async mounted() {
    this.initPriceMap();
  },
  watch: {
    company: function(newVal, oldVal) {
      this.initPriceMap();
    }
  }
};
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: 40% 10% 40%;
}
</style>
